<template>
    <v-card flat outlined>
        <v-card-title class="px-24" style="font-size:1.6rem">
            <span> 첨부파일 </span>
        </v-card-title>
        <v-card-text class="px-24">
            <v-row class="ma-n8">
                <template v-for="(field, index) in fields">
                    <v-col class="pa-8" cols="12" :key="field.tempId">
                        <side-file-item
                            v-model="fields[index]"
                            v-on="{
                                input: emit,
                                pull,
                            }"
                        />
                    </v-col>
                </template>
                <v-col class="pa-8" cols="12">
                    <v-card flat color="secondary lighten-5" @click="push">
                        <v-card-title style="font-size: 1.4rem">
                            <span> 파일추가 </span>
                            <v-spacer />
                            <v-icon size="20" color="black"> mdi-plus </v-icon>
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES, initEmploymentForm, initEmploymentField } from "@/assets/variables";

import SideFileItem from "./side-file-item.vue";

export default {
    components: {
        SideFileItem,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        fields: [],
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.fields = this.value.fields.filter((item) => item.side == EMPLOYMENT_FIELD_SIDES.EMPLOYEE.value && item.type == EMPLOYMENT_FIELD_TYPES.FILE.value);
        },
        emit() {
            let [...fields] = this.value.fields.filter((item) => !(item.side == EMPLOYMENT_FIELD_SIDES.EMPLOYEE.value && item.type == EMPLOYMENT_FIELD_TYPES.FILE.value));

            fields = fields.concat(...this.fields);

            this.$emit("input", { ...this.value, fields });
        },
        push() {
            this.fields.push(
                initEmploymentField({
                    side: EMPLOYMENT_FIELD_SIDES.EMPLOYEE.value,
                    type: EMPLOYMENT_FIELD_TYPES.FILE.value,
                    page: -1,
                })
            );
            this.emit();
        },
        pull(item) {
            let index = this.fields.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.fields.splice(index, 1);
            this.emit();
        },
    },
};
</script>

<style></style>
